import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/** Catches render errors in a pane/page so one failure can't blank the whole app. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Dashboard render error:', error, info);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="m-6 rounded-brand border border-brand-error-soft bg-brand-error-light p-6 text-center">
          <p className="font-medium text-brand-error">Noget gik galt i visningen.</p>
          <p className="mt-1 text-sm text-brand-dark/60">{this.state.error.message}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded-brand bg-brand-primary px-4 py-2 text-sm text-white hover:bg-brand-primary-hover"
          >
            Genindlæs
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
